import {createStore} from 'redux'
import languageReducer  from './language/languageReducer'
import { configureStore } from '@reduxjs/toolkit'

const store = createStore(languageReducer)
export type RootState = ReturnType<typeof store.getState>

export default store; configureStore({
    reducer: {}
  })